import React from "react";
import { HardHat, ShieldCheck, Clock } from "lucide-react";
import { FEATURES } from "../mock";

const ICONS = { HardHat, ShieldCheck, Clock };

export default function Features() {
  return (
    <section className="relative bg-white">
      <div className="max-w-7xl mx-auto px-6 -mt-16 relative z-20">
        <div className="grid md:grid-cols-3 gap-px bg-slate-200 rounded-xl overflow-hidden shadow-xl">
          {FEATURES.map((f, i) => {
            const Icon = ICONS[f.icon] || HardHat;
            return (
              <div
                key={f.title}
                className="group bg-white p-8 md:p-10 hover:bg-slate-900 transition-colors duration-300"
              >
                <div className="flex items-start gap-5">
                  <div className="shrink-0 w-14 h-14 rounded-lg bg-yellow-100 group-hover:bg-yellow-700 grid place-items-center transition-colors">
                    <Icon className="w-7 h-7 text-yellow-800 group-hover:text-white transition-colors" />
                  </div>
                  <div>
                    <div className="text-xs font-bold uppercase tracking-widest text-yellow-700">0{i + 1}</div>
                    <h3 className="display text-2xl font-bold text-slate-900 group-hover:text-white mt-1 transition-colors">{f.title}</h3>
                    <p className="mt-2 text-slate-600 group-hover:text-slate-300 leading-relaxed transition-colors">{f.text}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
